import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

constructor(private title: Title, private meta: Meta) { }

updateMetaInfo(description, author, keywords) {
  this.meta.updateTag({ name: 'description', content: description });
  this.meta.updateTag({ name: 'author', content: author });
  this.meta.updateTag({ name: 'keywords', content: keywords });
}

updateTitle(title?: string) {

    {  
      this.title.setTitle(title + ' | Investing for Catholics');
   }

}

}
